import {
  Avatar,
  Card,
  CardContent,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";


export const OverviewBudget = ({ sx, value, title, id, icon, loading = false }) => {
  const {t} = useTranslation();
  const text = [t("card.toman"), "", ""];
  return (
    <Card sx={sx}>
      <CardContent>
        <Stack
          alignItems="flex-start"
          direction="row"
          justifyContent="space-between"
          spacing={3}
        >
          <Stack spacing={1}>
            <Typography color="text.secondary" variant="overline">
              {loading ? <Skeleton width={60} /> : title}
            </Typography>
            <Typography variant="h6">
              {loading ? (
                <Skeleton width={80} height={30} />
              ) : (
                <>
                  {value.toLocaleString()} {text[id]}
                </>
              )}
            </Typography>
          </Stack>

          <Avatar
            sx={{
              backgroundColor: "#613377",
              height: 56,
              width: 56,
            }}
          >
            {loading ? <Skeleton variant="circular" width={40} height={40} /> : icon}
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
};
